import script from "./WechatId.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatId.vue?vue&type=script&setup=true&lang=js"

import "./WechatId.vue?vue&type=style&index=0&id=73eb6fa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73eb6fa4"]])

export default __exports__